const skills = [
    {
        id: 1,
        name: 'Beauty consultants'
    },
    {
        id: 2,
        name: 'Flooring specialist'
    },
    {
        id: 3,
        name: 'Heating and cooling services'
    },
    {
        id: 4,
        name: 'Licensed plumbing'
    },
    {
        id: 5,
        name: 'Landscaping - lawn maintenance'
    },
    {
        id: 6,
        name: 'Painting interior and exterior'
    },
    {
        id: 7,
        name: 'Professional Junk removal'
    },
    {
        id: 8,
        name: 'House deep cleaning and regular'
    },
    {
        id: 9,
        name: 'Upholstery cleaning'
    },
    {
        id: 10,
        name: 'Carpet cleaning'
    },
    {
        id: 11,
        name: 'Pressure washing interior and exterior'
    },
    {
        id: 12,
        name: 'Tile and grout cleaning'
    },
    {
        id: 13,
        name: 'Wood refinishing'
    },
    {
        id: 14,
        name: 'Wood polishing'
    },
    {
        id: 15,
        name: 'Kitchen remodel'
    },
    {
        id: 16,
        name: 'Bathroom remodel'
    },
    {
        id: 17,
        name: 'Patio remodel'
    },
    {
        id: 18,
        name: 'General house remodel'
    },
    {
        id: 19,
        name: 'Move in handyman repairs'
    },
    {
        id: 20,
        name: 'Move out handyman repairs'
    },
    {
        id: 21,
        name: 'Cabinet painting'
    },
    {
        id: 22,
        name: 'Roofing and building drywall'
    },
    {
        id: 23,
        name: 'Installation carpet'
    },
]

const roles = [
    {
        id: 1,
        name: 'Admin',
    },
    {
        id: 2,
        name: 'Client',
    },
    {
        id: 3,
        name: 'Professional',
    },
]

const services = [
    {
        id: 1,
        name: 'Plumbing',
    },
    {
        id: 2,
        name: 'Interior Decoration',
    },
    {
        id: 3,
        name: 'Construction',
    },
    {
        id: 3,
        name: 'Other',
    },
]

export {skills,roles, services}